import { render, staticRenderFns } from "./BonTemplate.vue?vue&type=template&id=1118a177"
import script from "./BonTemplate.vue?vue&type=script&lang=js"
export * from "./BonTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports